var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.companyInfo)?_c('div',{staticClass:"wrapper"},[_c('div',[_c('PurchaseAndSaleTabItem',{attrs:{"zq":_vm.companyInfo.zq,"taxNo":_vm.companyInfo.taxNo,"companyType":_vm.activeIndex}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }